// import { NetNewTitleMenu } from "./NetNewTitleMenu";
import { NetNewChart } from "./NetNewChart";
import { Loader } from "../../../assets/icons/FallBackComponents";

export const NetNewBody = (props) => {
  const { isLoading } = props;

  return (
    <>
      <div className="net-new-body">
        {/* <NetNewTitleMenu /> */}
        <div className="chart">
          {isLoading ? <Loader />
           : 
           <NetNewChart />
          }
        </div>
        {/* <div className="net-new-legends">
          <p className="intent"><div></div> Intent</p>
          <p className="web"><div></div> Web</p>
          <p className="linkedin"><div></div> Linkedin</p>
        </div> */}
        {/* <a href="">View All</a> */}
      </div>
    </>
  );
};
